import { render } from "./Manual.vue?vue&type=template&id=6966fe32&scoped=true&ts=true"
import script from "./Manual.vue?vue&type=script&setup=true&lang=ts"
export * from "./Manual.vue?vue&type=script&setup=true&lang=ts"

import "./Manual.vue?vue&type=style&index=0&id=6966fe32&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3191932516/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6966fe32"],['__file',"src/components/scan/parts/Manual.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6966fe32"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6966fe32', __exports__)) {
    console.log('reload')
    api.reload('6966fe32', __exports__)
  }
  
  module.hot.accept("./Manual.vue?vue&type=template&id=6966fe32&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6966fe32', render)
  })

}


export default __exports__